'use client';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import HeroSection from '@/app/(football)/[team]/point-lounge/_components/HeroSection';
import Tab from '@/app/(football)/[team]/point-lounge/_components/Tab';
import UseList from '@/app/(football)/[team]/point-lounge/_components/UseList';

export default function UseContainer() {
  const { teamSlug } = useTeamConfig();

  return (
    <div
      className="px-5 pt-10 pb-football-page-bottom"
      style={{
        backgroundColor: 'var(--color-point-lounge-use-container-bg)',
        backgroundImage: `url('https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/point-lounge/bg.webp')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: '480px 1033px',
      }}
    >
      <HeroSection />
      <Tab />
      <UseList />
    </div>
  );
}
